import {
	animate,
	query,
	stagger,
	state,
	style,
	transition,
	trigger,
} from '@angular/animations';

export const calendarTransition = trigger('calendarTransition', [
	transition(':enter', [
		style({ transform: 'translateX(40%)', opacity: 0 }),
		animate(
			'200ms ease-in',
			style({ transform: 'translateX(0)', opacity: 1 })
		),
	]),
]);

export const animateList = trigger('animateList', [
	transition('* => *', [
		query(
			':enter',
			[
				style({ transform: 'translateY(200%)', opacity: 0 }),
				stagger(50, [
					animate(
						'300ms cubic-bezier(0.35, 0, 0.25, 1)',
						style({ opacity: 1, transform: 'none' })
					),
				]),
			],
			{ optional: true }
		),
	]),
]);

export const animateError = trigger('animateError', [
	state(
		'enter',
		style({
			height: '*',
			opacity: '1',
		})
	),
	state(
		'leave, void',
		style({
			height: '0',
		})
	),
	transition('void => *', [
		style({ height: '0', opacity: '1' }),
		animate('500ms cubic-bezier(0, 1, 0.5, 1)'),
	]),
	transition('* => void', [
		style({ height: '*' }),
		animate('500ms cubic-bezier(0, 1, 0.5, 1)'),
	]),
]);

export const expandTable = trigger('detailExpand', [
	state(
		'collapsed',
		style({ height: '0px', minHeight: '0', display: 'none' })
	),
	state('expanded', style({ height: '*' })),
	transition(
		'expanded <=> collapsed',
		animate('2ms cubic-bezier(0.4, 0.0, 0.2, 1)')
	),
]);

export const slideInSlideOut = trigger('slideInSlideOut', [
	transition(':enter', [
		style({ transform: 'translateX(100%)', opacity: 0 }),
		animate(
			'500ms ease-in',
			style({ transform: 'translateX(0)', opacity: 1 })
		),
	]),
	transition(':leave', [
		style({ transform: 'translateX(0)', opacity: 1 }),
		animate(
			'500ms ease-out',
			style({ transform: 'translateX(100%)', opacity: 0 })
		),
	]),
]);

export const slideUpSlideDown = trigger('slideUpSlideDown', [
	transition(':enter', [
		style({ transform: 'translateY(100%)', opacity: 0 }),
		animate(
			'300ms ease-in',
			style({ transform: 'translateY(0)', opacity: 1 })
		),
	]),
	transition(':leave', [
		style({ transform: 'translateY(0)', opacity: 1 }),
		animate(
			'300ms ease-out',
			style({ transform: 'translateY(100%)', opacity: 0 })
		),
	]),
]);

export const verticalExpandAndCollapse = trigger('verticalExpandAndCollapse', [
	state(
		'enter',
		style({
			width: '*',
			opacity: '1',
		})
	),
	state(
		'leave, void',
		style({
			width: '0',
			opacity: '0',
		})
	),
	transition('void => *', [
		style({ width: '0', opacity: '1' }),
		animate('500ms cubic-bezier(0, 1, 0.5, 1)'),
	]),
	transition('* => void', [
		style({ width: '*' }),
		animate('500ms cubic-bezier(0, 1, 0.5, 1)'),
	]),
]);
